import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/**
 * 認証エラーアクションクリエータ
 */
export const commonHandleAuthError = actionCreator<{}>(
	'COMMON_HANDLE_AUTH_ERROR'
);

/**
 * セッションタイムアウトアクションクリエータ
 */
export const commonHandleSessionTimeout = actionCreator<{}>(
	'COMMON_HANDLE_SESSION_TIMEOUT'
);

/**
 * 排他エラーアクションクリエータ
 */
export const commonHandleExclusionError = actionCreator<{}>(
	'COMMON_HANDLE_EXCLUSION_ERROR'
);

/**
 * エラーメッセージ表示アクションクリエータ
 */
export const commonHandleShowErrorMessage = actionCreator<{
	content: string;
	replacements?: string[];
	withLogout?: boolean;
}>('COMMON_HANDLE_SHOW_ERROR_MESSAGE');

/**
 * エラーメッセージ非表示アクションクリエータ
 */
export const commonHideErrorMessage = actionCreator<{}>(
	'COMMON_HIDE_ERROR_MESSAGE'
);

/**
 * ストア初期化アクションクリエータ
 */
export const initializeStore = actionCreator<{}>('INITIALIZE_STORE');



// WEBPACK FOOTER //
// ./src/actions/common.ts